



























import {Component, Mixins} from 'vue-mixin-decorator';

import SystemKernelLogs from '@/components/System/Logs/SystemKernelLogs.vue';
import SystemUserLogs from '@/components/System/Logs/SystemUserLogs.vue';

export class LogLevelMetadata {
  public label!: string;
  public index!: number;
  public color!: string;

  constructor(label: string, index: number, color: string) {
    this.label = label;
    this.index = index;
    this.color = color;
  }
}

enum LogTabs {
  User,
  Kernel,
}

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {SystemUserLogs, SystemKernelLogs},
})
export default class SystemLogsPage extends Mixins<BaseComponent>(BaseComponent) {
  private LogTabs = LogTabs;
  private selectedTab: LogTabs = LogTabs.User;
}
